import React, { useEffect, useRef, useState } from 'react';
import './BookingDiagnostics.css';
const KEY = 'primeink:booking-diagnose';
const enabled = () => new URLSearchParams(window.location.search).get('bookingDiagnose') === '1';
function readReport() {
  try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (_) { return {}; }
}
function saveReport(report) {
  try { sessionStorage.setItem(KEY, JSON.stringify(report)); } catch (_) { /* Diagnosis still works without storage. */ }
}
export default function BookingDiagnostics({ renderCount, days, loading, locationId }) {
  const [report, setReport] = useState(null);
  const latest = useRef({ days, loading, locationId });
  latest.current = { days, loading, locationId };
  useEffect(() => {
    if (!enabled()) return undefined;
    const previous = readReport();
    if (!window.__primeInkBookingDocumentStarted) {
      window.__primeInkBookingDocumentStarted = true;
      previous.starts = [...(previous.starts || []), new Date().toISOString()].slice(-10);
    }
    let current = { ...previous, userAgent: navigator.userAgent };
    const update = () => {
      const data = latest.current;
      current = { ...current, updated: new Date().toISOString(), loading: data.loading,
        locationId: data.locationId, days: data.days.length,
        appointments: data.days.reduce((sum, day) => sum + (day.appointments?.length || 0), 0),
        bookingRenders: renderCount.current, scrollY: Math.round(window.scrollY),
        viewport: { width: window.innerWidth, height: window.innerHeight,
          visibleHeight: window.visualViewport?.height, visibleTop: window.visualViewport?.offsetTop } };
      saveReport(current); setReport(current);
    };
    const recordError = message => {
      current.errors = [...(current.errors || []), { time: new Date().toISOString(), message: String(message).slice(0, 500) }].slice(-8);
      update();
    };
    const onError = event => recordError(event.message || 'JavaScript-Fehler');
    const onRejection = event => recordError(event.reason?.message || 'Nicht abgefangener Promise-Fehler');
    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onRejection);
    update();
    const timer = setInterval(update, 1000);
    return () => {
      clearInterval(timer);
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onRejection);
    };
  }, [renderCount]);
  if (!enabled() || !report) return null;
  const download = () => {
    const url = URL.createObjectURL(new Blob([JSON.stringify(report, null, 2)], { type: 'application/json' }));
    const link = document.createElement('a'); link.href = url; link.download = 'booking-diagnose.json'; link.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  return <details className="booking-diagnostics" open>
    <summary>Booking-Diagnose</summary>
    <div>Seitenstarts: {report.starts?.length || 0} · Kalenderaufbauten: {report.bookingRenders}</div>
    <div>{report.loading ? 'Kalender lädt' : 'Kalender geladen'} · {report.days} Tage · {report.appointments} Termine</div>
    <div>Fehler: {report.errors?.length || 0}</div>
    {report.errors?.length > 0 && <p>{report.errors[report.errors.length - 1].message}</p>}
    <button type="button" onClick={download}>Diagnose herunterladen</button>
  </details>;
}
